module.exports = __webpack_public_path__ + "media/images/front/home/sello-dc1a5dea43ca40b5cf4fd69b3616d1f6.png";